<template>
    <div id="certificateDataPage">
        <h2 orientation="left" class="text-xl font-normal pt-8 pb-8">
            Certificates
        </h2>

        <table class="w-full pr-5 pl-5">
            <thead>
                <tr>
                    <th>Certificate ID</th>
                    <th>Date issued</th>
                    <th>Product</th>
                    <th>Land area</th>
                </tr>
            </thead>
            <tr v-for="(eachCert, key) in certificateData" :key="'certs' + key">
                <td>
                    <router-link
                        :to="{
                            name: 'view-land-record',
                            params: { id: eachCert.id }
                        }"
                    >
                        <!-- eslint-disable-next-line -->
                        {{ eachCert.certificateID }}
                        <!-- eslint-disable-next-line -->
                    </router-link>
                </td>
                <td>{{ dateTimeFormatter(eachCert.dateIssued) }}</td>
                <td>{{ eachCert.productType }}</td>
                <td>{{ calculateWithUnits(eachCert.landAreaInM2,$store.state.globalSettings.AREA_UNIT) }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import asyncRequest from "./../../utils/asyncRequest.js";
import { fromGramsTo } from "../../utils/weightConverter.js";
import { ConvertFromM2To } from "../../utils/areaConverter.js";
import Mapbox from "mapbox-gl-vue";
//import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
const mapboxgl = require("mapbox-gl/dist/mapbox-gl");

export default {
    name: "InventoryView",
    created() {
        this.getAllTransactionsByUserAllOpID();
    },
    computed: {},
    data() {
        return {
            certificateData: []
        };
    },
    methods: {
        getAllTransactionsByUserAllOpID() {
            asyncRequest.ServerAPI({
                method: "GET",
                api: this.$store.state.urls.GET_ALL_CERTIFICATES_BY_ALL_OP_ID,
                onSuccessCallback: dataIn => {
                    this.reorganizeCertificateData(dataIn);
                },
                postData: null,
                flags: asyncRequest.M_FAIL,
                customSuccessMessage: "",
                customErrorMessage: "",
                beforeAfterCallback: false
            });
        },
        calculateWithUnits(valInM2, unit) {
            var convertedData = ConvertFromM2To(unit, valInM2);
            //If this func returns nothing
            if (convertedData == 0) {
                this.convertedAreaVal = "";
                return;
            }
            this.convertedAreaVal = convertedData.areaInConvertedUnit;
            this.convertedAreaSI = convertedData.unitConvertedToSI;

            return  this.convertedAreaVal + " " +this.convertedAreaSI
        },
        reorganizeCertificateData(dataIn) {
            this.certificateData = [];
            if (!Array.isArray(dataIn.Data)) {
                return;
            }

            for (var i = 0; i < dataIn.Data.length; i++) {
                this.certificateData = dataIn.Data;
                this.certificateData[i].id = dataIn.Data[i].CertificateID;
                this.certificateData[i].certificateID = dataIn.Data[i].CertificateID;
                this.certificateData[i].dateIssued = dataIn.Data[i].IssuedOn;
                this.certificateData[i].productType = dataIn.Data[i].ProductName;
                this.certificateData[i].landAreaInM2 = dataIn.Data[i].LandMarkedGEOJsonArea;
            }
        },
        dateTimeFormatter(dataIn) {
            return this.$dateFns.format(new Date(dataIn), "Do-MMMM-YYYY", {
                locale: this.$dateFns.locale
            });
        },
        getQuantityWithUnit(valIn) {
            var decimalPoints = 4;
            var retVal = fromGramsTo(this.$store.state.globalSettings.WEIGHT_UNIT.value, valIn, decimalPoints);
            return retVal;
        }
    },
    components: { Mapbox }
};
</script>

<style>
#certificateDataPage {
    padding: 5px 15px;
    min-height: calc(100vh - 172px);
}
#certificateDataPage .cstmPopup {
    padding: 20px;
}
#certificateDataPage .innerHtmlPopupTxType {
    font-weight: bold;
}
#certificateDataPage .innerHtmlPopupTxDate {
    font-style: italic;
}
</style>
